/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OnEarly Core API
 * OnEarly Core HTTP API
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const contentTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax = 8;

export const contentTypeDefinitionReferenceViewPredicatesMax = 10;

export const contentTypeDefinitionReferenceViewSearchTermsItemMax = 200;

export const contentTypeDefinitionReferenceViewSearchTermsMax = 10;

export const ContentTypeDefinition = zod
  .object({
    conformance: zod.enum(['open', 'lax', 'strict']).optional(),
    description: zod.string().nullish(),
    enums: zod
      .array(
        zod.object({
          label: zod.string(),
          value: zod.string(),
        }),
      )
      .nullish(),
    file: zod
      .object({
        allowedFormats: zod
          .array(
            zod.enum([
              'pdf',
              'doc',
              'docx',
              'xls',
              'xlsx',
              'csv',
              'txt',
              'jpeg',
              'png',
              'webp',
              'gif',
              'heic',
              'md',
              'html',
              'mp3',
              'm4a',
              'wav',
              'mp4',
              'mov',
              'webm',
            ]),
          )
          .min(1)
          .optional(),
      })
      .nullish(),
    metadata: zod.record(zod.string(), zod.unknown()).nullish(),
    reference: zod
      .object({
        carbonCopy: zod.boolean().optional(),
        creation: zod.enum(['forbidden', 'optional', 'required']).optional(),
        edgeType: zod.enum(['INCLUDES', 'RELATES_TO']).optional(),
        typeLineageUuid: zod.uuid(),
        typeUuid: zod.uuid(),
        view: zod
          .object({
            predicates: zod
              .array(
                zod.object({
                  op: zod.enum(['exists', 'eq', 'contains', 'gte', 'lte']),
                  pathTypeUuids: zod
                    .array(zod.uuid())
                    .min(1)
                    .max(contentTypeDefinitionReferenceViewPredicatesItemPathTypeUuidsMax),
                  value: zod.string().optional(),
                  valueType: zod
                    .enum(['STRING', 'NUMERIC', 'BOOLEAN', 'DATE', 'DATETIME'])
                    .optional(),
                }),
              )
              .max(contentTypeDefinitionReferenceViewPredicatesMax)
              .optional(),
            searchTerms: zod
              .array(zod.string().min(1).max(contentTypeDefinitionReferenceViewSearchTermsItemMax))
              .max(contentTypeDefinitionReferenceViewSearchTermsMax)
              .optional(),
          })
          .nullish(),
      })
      .nullish(),
    signature: zod.looseObject({}).nullish(),
  })
  .nullable()
  .describe(
    'Stored TYPE configuration: description, arbitrary metadata, ENUM value\/label pairs, and the reference \/ file \/ signature field bags.',
  );

export type ContentTypeDefinition = zod.input<typeof ContentTypeDefinition>;
export type ContentTypeDefinitionOutput = zod.output<typeof ContentTypeDefinition>;
